// We will rename navigationSlice.ts to contextSlice.ts (or just update the existing file)
// File: noviopus-ats-client/src/features/Navigation/navigationSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { NavigationState, ServiceContextType } from './types';

// Updated Initial State to include activeOrganizationId
const initialState: NavigationState = {
  activeServiceContext: 'recruitment',
  activeSubMenu: null,
  activeJobId: null,
  activeOrganizationId: null, // NEW: 'null' means "All Organizations"
  isSidebarOpen: false,
};

const navigationSlice = createSlice({
  name: 'navigation', // We can keep the name 'navigation' for reducers mapping compatibility
  initialState,
  reducers: {
    // --- SERVICE CONTEXT ---
    setActiveServiceContext: (state, action: PayloadAction<ServiceContextType>) => {
      state.activeServiceContext = action.payload;
    },
    setActiveSubMenu: (state, action: PayloadAction<string | null>) => {
      state.activeSubMenu = action.payload;
    },
    
    // --- ENTITY CONTEXT ---
    setActiveOrganization: (state, action: PayloadAction<string | null>) => {
        state.activeOrganizationId = action.payload;
    },
    setActiveJob: (state, action: PayloadAction<string>) => {
        state.activeJobId = action.payload;
        state.activeServiceContext = 'job';
        state.activeSubMenu = null;
    },
    clearActiveJob: (state) => {
        state.activeJobId = null;
        if (state.activeServiceContext === 'job') {
            state.activeServiceContext = 'recruitment';
        }
    },
    
    // --- UI STATE ---
    toggleSidebar: (state) => {
      state.isSidebarOpen = !state.isSidebarOpen;
    },
    setSidebarOpen: (state, action: PayloadAction<boolean>) => {
      state.isSidebarOpen = action.payload;
    },
  },
});

export const {
  setActiveServiceContext,
  setActiveSubMenu,
  setActiveOrganization, // NEW
  setActiveJob,
  clearActiveJob,
  toggleSidebar,
  setSidebarOpen
} = navigationSlice.actions;

export default navigationSlice.reducer;